// 액션 타입 정의
export const UPDATE_CART = 'UPDATE_CART';
export const ADD_TO_CART = 'ADD_TO_CART';
export const REMOVE_FROM_CART = 'REMOVE_FROM_CART';
export const CLEAR_CART = 'CLEAR_CART';

// 액션 생성자 함수들
export const updateCart = (cartItems) => ({
  type: UPDATE_CART,
  payload: cartItems
});

export const addToCart = (item, quantity = 1) => {
  // 로컬 스토리지에서 현재 장바구니 불러오기
  const cartItems = JSON.parse(localStorage.getItem("cart") || "[]");
  
  // 이미 존재하는 아이템인지 확인
  const existingItemIndex = cartItems.findIndex(cartItem => cartItem.id === item.id);
  
  if (existingItemIndex >= 0) {
    // 이미 장바구니에 있는 아이템이면 수량 업데이트
    cartItems[existingItemIndex].quantity += quantity;
  } else {
    // 새 아이템이면 추가
    cartItems.push({
      ...item,
      quantity: quantity
    });
  }
  
  // 로컬 스토리지 업데이트
  localStorage.setItem("cart", JSON.stringify(cartItems));
  
  return {
    type: ADD_TO_CART,
    payload: cartItems
  };
};

export const removeFromCart = (index) => {
  // 로컬 스토리지에서 현재 장바구니 불러오기
  const cartItems = JSON.parse(localStorage.getItem("cart") || "[]");
  
  // 아이템 제거
  cartItems.splice(index, 1);
  
  // 로컬 스토리지 업데이트
  localStorage.setItem("cart", JSON.stringify(cartItems));
  
  return {
    type: REMOVE_FROM_CART,
    payload: cartItems
  };
};

export const clearCart = () => {
  // 로컬 스토리지 장바구니 비우기
  localStorage.setItem("cart", JSON.stringify([]));
  
  return {
    type: CLEAR_CART
  };
};